import MemberDetailFull from './MemberDetailFull'

export * from './types';

export default MemberDetailFull;